import React from "react";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";

import { Chip } from "@mui/material";

import DataTable from "../../../common/DataTable";
import ColumnHeader from "../../../common/ColumnHeader";
import { getChipColor } from "../../../../constants/value";
import { dateSortComparator } from "../../../../utils/date";

const PortinList = ({
  data,
  meta,
  client,
  loading,
  handleSort,
  disableRowClick,
  handlePageChange,
  handleColumnClick,
  handleFilterChange,
  handlePageSizeChange,
  ...props
}) => {
  const nav = useNavigate();
  const handleRowClick = (e) => {
    nav(`/ultra/portin/${e.row.id}`);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    {
      field: "iccid",
      headerName: "ICCID",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"ICCID"}
            handleClick={() => handleColumnClick("iccid")}
          />
        ) : (
          "ICCID"
        ),
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 120,
      flex: 2,
      renderCell: (params) => (
        <Chip
          label={params.row.status}
          size="small"
          color={getChipColor(params.row.status)}
        />
      ),
      sortable: false,
    },
    { field: "plan_id", headerName: "Plan ID", flex: 1, sortable: false },
    {
      field: "plan",
      headerName: "Plan",
      minWidth: 250,
      flex: 4,
      sortable: false,
    },
    {
      field: "zipcode",
      headerName: "Zipcode",
      minWidth: 75,
      flex: 1,
      sortable: false,
    },
    {
      field: "msisdn",
      headerName: "MSISDN",
      minWidth: 100,
      flex: 2,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"MSISDN"}
            handleClick={() => handleColumnClick("msisdn")}
          />
        ) : (
          "MSISDN"
        ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.created_at || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.last_updated || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
  ];

  return (
    <DataTable
      disableColumnFilter
      loading={loading}
      data={data}
      columns={
        client ? columns.map((val) => ({ ...val, sortable: true })) : columns
      }
      metaData={meta}
      handleRowClick={disableRowClick ? null : handleRowClick}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
      filterMode={client ? "client" : "server"}
      client={client}
      {...props}
    />
  );
};

export default PortinList;
